import React from 'react';

const MobileContentWrapper = ({ children, className = "", compactTop = false }) => {
  return (
    <div className={`min-h-full bg-gray-50 overflow-hidden ${className}`}>
      {/* Mobile padding and spacing */}
      <div className={`px-4 ${compactTop ? 'pt-3 md:pt-4 pb-6 md:pb-8' : 'py-6 md:py-8'} space-y-4 md:px-6 h-full overflow-y-auto`}>
        {children}
      </div>
    </div>
  );
};

export default MobileContentWrapper;
